import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black ${
        scrolled ? 'shadow-lg' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/629c9343645c6844591b8b96cb81f5f4/a8f8b5c882432f4c1a0b17d9e5ef2291.jpeg"
              alt="PACKTO Smart Solutions"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-orange-400"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-orange-400"
            >
              Soluciones
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-orange-400"
            >
              Proyectos
            </button>
            <button
              onClick={() => scrollToSection('team')}
              className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-orange-400"
            >
              Equipo
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-green-500 text-white text-sm font-semibold rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Contacto
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
